export const ENVIO_A_DOMICILIO_CON_PAGO_EN_DESTINO= 'Envío a domicilio con pago en destino';
export const ENVIO_A_DOMICILIO_CON_PAGO_EN_DESTINO_ID= 1;
export const PICKUP_CON_PAGO_EN_DESTINO= 'Retira en punto de PickUp';
export const PICKUP_CON_PAGO_EN_DESTINO_ID= 2;